module.exports = __webpack_public_path__ + "static/media/walmart-logo.e5b15748.svg";